export default __webpack_public_path__ + "static/media/FP-3.8cd891e4.png";